function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  // Insert immediately. If the image is already cached (see preloadZoomImages
  // below), this paints instantly. If not, the gradient background (set in
  // prepareOverlay) shows briefly instead of a blank box until it loads.
  image.parentElement.insertBefore(overlay, image);

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio = 2) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onmouseenter = null;
    image.onmouseenter = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

// Warm the browser cache with the full-size zoom images ahead of time so the
// hover overlay above is instant instead of waiting on a fresh fetch.
function preloadZoomImages() {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = image.src;
    link.fetchPriority = 'low'; // don't compete with the LCP image
    document.head.appendChild(link);
  });
}

enableZoomOnHover(2);
preloadZoomImages();

document.addEventListener('shopify:section:load', () => {
  enableZoomOnHover(2);
  preloadZoomImages();
});
document.addEventListener('shopify:section:reorder', () => {
  enableZoomOnHover(2);
  preloadZoomImages();
});